export default () => ({
  user: {},
  backendToken: "",
  isAuthenticated: false,
  currentRequestId: null,
  userSocials: [],
});
